import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { EyeIcon } from '../../../../../../utils/SVGIcon';
import { GetDate } from '../../../../../../utils/Show';
import { mkRelativeUrl } from '../../../../../../utils/URL';
import cn from '../../../../../../utils/cn';

function SupportTicketTr({ item }) {
    const navigate = useNavigate();
    return (
        <tr
            className={cn(`group`, {
                'placeholder-mode': item?.demo
            })}
            // onClick={handleAppInfoModal}
        >
            <td>
                <span>{item?.id}</span>
            </td>
            <td className="group-hover:font-medium group-hover:text-secondary hover:underline cursor-pointer">
                <Link
                    to={mkRelativeUrl(
                        `/agency/${item?.customerInfo?.agencyId}/customers/${item?.customerInfo?.id}/info`
                    )}
                    className="flex flex-col gap-1"
                >
                    <span>{item?.customerInfo?.organization}</span>
                    <span className="text-xs text-primary-500 truncate max-w-[200px]">
                        {item?.customerInfo?.email}
                    </span>
                </Link>
            </td>
            <td>
                <span>{item?.subscriptionId}</span>
            </td>
            <td className="capitalize">
                <span>{item?.department}</span>
            </td>
            <td
                onClick={() => mkRelativeUrl(navigate(`/support-ticket/${item?.id}/info`))}
                className="cursor-pointer group-hover:text-secondary hover:underline"
            >
                <span className="text-ellipsis overflow-hidden w-full block first-letter:!uppercase group-hover:font-medium capitalize">
                    {item?.subject || '-----'}
                </span>
            </td>
            <td className="hidden xl:table-cell">
                <span className="line-clamp-1">{item?.lastMessage}</span>
            </td>
            <td>
                <span>{GetDate(item?.timeCreated) || '-----'}</span>
            </td>
            <td className="text-center">
                <span>{GetDate(item?.timeUpdated || '-----')}</span>
            </td>
            <td
                className={cn('text-center capitalize', {
                    '*:text-success': item?.status === 'open',
                    '*:text-error': item?.status === 'closed'
                })}
            >
                <span>{item?.status}</span>
            </td>

            <td className="text-center">
                <span>
                    <button
                        type="button"
                        onClick={() => navigate(mkRelativeUrl(`/support-ticket/${item?.id}/info`))}
                        data-tooltip-id="myToolTip"
                        data-tooltip-content="View Ticket"
                        className="size-[31px] p-[5px] rounded-[7px] text-secondary-700 hover:text-secondary"
                    >
                        <EyeIcon />
                    </button>
                </span>
            </td>
        </tr>
    );
}

function SupportTicketTableHeader() {
    return (
        <thead>
            <tr>
                <th scope="col">
                    <span>ID</span>
                </th>
                <th scope="col" className="w-30">
                    <span data-tooltip-id="tblTooltip" data-tooltip-content="Subscription Id">
                        Subs. ID
                    </span>
                </th>
                <th scope="col" className="!text-left w-42">
                    <span>Customer Info</span>
                </th>
                <th scope="col" className="w-30">
                    <span>Department</span>
                </th>
                <th scope="col">
                    <span>Subject</span>
                </th>
                <th scope="col" className="hidden xl:table-cell">
                    <span>Last Message</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Date Created</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Date Updated</span>
                </th>
                <th scope="col" className="w-30 text-center">
                    <span>Status</span>
                </th>
                <th scope="col">#</th>
            </tr>
        </thead>
    );
}
function TableWeb({ data }) {
    return (
        <div className="agency_info_support_ticket_table pb-40 overflow-x-auto">
            <table className="bik-table" cellPadding={0} cellSpacing={0}>
                <SupportTicketTableHeader />
                <tbody>
                    {data && data?.supportTickets?.length === 0 ? (
                        <tr className="hover:!bg-inherit">
                            <td colSpan={9} className="!text-left">
                                No Support-ticket Found!
                            </td>
                        </tr>
                    ) : (
                        data?.supportTickets?.map((item) => (
                            <SupportTicketTr key={item.id} item={item} />
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
}

export default TableWeb;
